<template>
  <ApplyDecision
    v-bind="props"
    component-type="ApplyPendingOfferDecision"
    decision="pending_offer"
  />
</template>

<script setup lang="ts">
  import { ApplyDecisionProps } from "@/models/apply/apply-models"
  import ApplyDecision from "@/components/apply/ApplyDecision.vue"

  const props = defineProps<ApplyDecisionProps>()
</script>
